module.exports = {
  "__version": "9.5.2"
}
